import script from "./PandoraInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraInput.vue?vue&type=script&setup=true&lang=js"

import "./PandoraInput.vue?vue&type=style&index=0&id=007fe8b0&lang=css"

const __exports__ = script;

export default __exports__